
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/payment/loan-payment",
      function () {
        return require("private-next-pages/dashboard/payment/loan-payment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/payment/loan-payment"])
      });
    }
  